/** @jsx jsx */
import { useState } from 'react'
import { css, jsx } from '@emotion/core'
import { ModalBase } from '@livechat/design-system'
import moreIcon from '../assets/icons/more.svg'
import deleteIcon from '../assets/icons/red-close.svg'
import infoIcon from '../assets/icons/info.svg'

const moreCss = css`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  position: relative;

  .more {
    width: 20px;
    margin-top: 10px;
    margin-right: 10px;
    cursor: pointer;
    transition: all 0.2s ease-in-out;

    :hover {
      transform: scale(1.1);
    }
  }

  .dropdown {
    position: absolute;
    top: 5px;
    left: 190px;
    width: 150px;
    height: 68px;
    background-color: white;
    box-shadow: 0 1px 10px 0 rgba(66, 77, 87, 0.3);
    border-radius: 4px;

    > div {
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      padding: 7px 10px;

      :hover {
        background-color: #e2e9ec;
      }

      > img {
        width: 17px;
        margin-right: 2px;
        margin-bottom: -2px;
      }
    }
  }
`

const More = ({ structure, handleDrop }) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false)
  const [isContentOpen, setIsContentOpen] = useState(false)
  return (
    <div css={moreCss}>
      <img
        src={moreIcon}
        onClick={() => setIsDropdownOpen(!isDropdownOpen)}
        className="more"
        alt="drop survey"
      />
      {isDropdownOpen && (
        <div className="dropdown" onMouseLeave={() => setIsDropdownOpen(false)}>
          <div
            onClick={() => {
              setIsContentOpen(true)
              setIsDropdownOpen(false)
            }}
          >
            <img src={infoIcon} alt="info" />
            <span>about</span>
          </div>
          <div onClick={handleDrop}>
            <img src={deleteIcon} alt="remove survey" />
            <span
              css={css`
                color: #e30d34;
              `}
            >
              delete
            </span>
          </div>
        </div>
      )}
      {isContentOpen && (
        <ModalBase
          onClose={() => setIsContentOpen(false)}
          style={{ width: '600px', height: '400px' }}
        >
          <div style={{ margin: 'auto' }}>content</div>
        </ModalBase>
      )}
    </div>
  )
}

export default More
